import teamRequestCardDetailsComponent from './teamRequestCardDetails.component';
import teamRequestCoincidences from './teamRequestCoincidences/teamRequestCoincidences';
import teamRequestCoincidencesMobile from './teamRequestCoincidencesMobile/teamRequestCoincidencesMobile';

let teamRequestCardDetailsModule = angular.module('vacations-absences.teamRequestCardDetails', [
  teamRequestCoincidences,
  teamRequestCoincidencesMobile
])

  .component('teamRequestCardDetails', teamRequestCardDetailsComponent)

  .name;

export default teamRequestCardDetailsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCardDetails.js